"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreCustomerChangedEventTypeEnum = void 0;
var BillingCoreCustomerChangedEventTypeEnum;
(function (BillingCoreCustomerChangedEventTypeEnum) {
  /** Создан новый плательщик */
  BillingCoreCustomerChangedEventTypeEnum["CREATED"] = "CREATED";
  /** Обновлён существующий плательщик */
  BillingCoreCustomerChangedEventTypeEnum["UPDATED"] = "UPDATED";
  /**
   * Изменился статус средств оплаты плательщика
   * - карта искла
   * - добавилась новая карта
   * - удалил карту
   * и т.д. (любое событие связанное с изменением списка платёжных счетов)
   */
  BillingCoreCustomerChangedEventTypeEnum["PM_CHANGED"] = "PM_CHANGED";
})(BillingCoreCustomerChangedEventTypeEnum = exports.BillingCoreCustomerChangedEventTypeEnum || (exports.BillingCoreCustomerChangedEventTypeEnum = {}));
